import { render } from "./Settings.vue?vue&type=template&id=202243de&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=202243de&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202243de"]])

export default __exports__